(function () {
  'use strict';

  angular
  .module('VImageCrop', [
    'ngImgCrop',
    'alert-message'
  ]);
}());
